export class GChartLegendSelectedEvent {
  event: any;
  nativeSeries: any[];
  mergeOptionsFn: Function;
  constructor(init: Readonly<GChartLegendSelectedEvent>) {
    Object.assign(this, init);
  }
}
